export default __webpack_public_path__ + "static/media/cloudUpload.3df4e5de.svg";